<template>
    <v-col
        :cols="width"
    >
        <v-label v-if="item.props.label">{{item.props.label}}</v-label>
        <!-- If the row property is set, render horizontally -->
        <v-row v-if="item.props.row" >
            <v-col
                :key="`checkboxlist-${thisItem.value}-${index}`"
                cols="4"
                class="justify-space-between"
                v-for="(thisItem, index) in item.props.items"
            >
                <v-checkbox
                    :key="thisItem.value + index"
                    :label="thisItem.text"
                    :disabled="readonly || item.props.readonly"
                    hide-details
                    color="primary"
                    v-model="modelData"
                    :value="thisItem.value"
                    @change="handleChange(thisItem.value, $event)"
                />
                <template v-if="item.props.withDescription" v-slot:label>
                    <div v-html="thisItem.text"></div>
                </template>

                <template v-if="item.props.tooltip" v-slot:append>
                    <v-tooltip
                        top
                        max-width="300"
                    >
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information</v-icon>
                        </template>
                        <div v-html="item.props.tooltip"></div>
                    </v-tooltip>
                </template>
            </v-col>
        </v-row>

        <!-- row property is not set, render vertically -->
        <template v-else>
            <v-checkbox
                :key="thisItem.value + index"
                :label="thisItem.text"
                :disabled="readonly || item.props.readonly"
                :multiple="item.props.multiple"
                hide-details
                color="primary"
                v-for="(thisItem, index) in item.props.items"
                v-model="modelData"
                :value="thisItem.value"
                v-on:change="handleChange(thisItem.value, $event)"
                :class="item.props.withDescription ? 'my-2 py-2' : 'my-2 py-0'"
            >
                <template v-if="item.props.withDescription" v-slot:label>
                    <div v-html="thisItem.text"></div>
                </template>
                <template v-if="thisItem.props && thisItem.props.indent" v-slot:prepend>
                    <div style="width: 20px"></div>
                </template>
                <template v-else-if="item.props.tooltip" v-slot:append>
                    <v-tooltip
                        top
                        max-width="620"
                    >
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information</v-icon>
                        </template>
                        {{item.props.tooltip}}
                    </v-tooltip>
                </template>
            </v-checkbox>
        </template>
        <v-input
            :rules="rules"
            :value="modelData"
            class="secret-input"
            ref="input"
        />
    </v-col>
</template>
<script>
    export default {
        name: 'CheckboxList',
        props: ['item', 'value', 'readonly', 'rules', 'optional', 'width'],
        computed: {
            modelData: {
                // GETTER: Used to populate the v-model of the checkboxes.
                // It reads the current value from the parent component's prop.
                get() {
                    // console.log('modelData GET', this.value || []);
                    // Assuming 'value' is a prop passed from the parent.
                    return this.value || [];
                },

                // SETTER: Called automatically whenever the v-model on the internal checkboxes changes (e.g., user clicks a checkbox).
                // The setter's responsibility is to communicate the change back to the parent component.
                set(newValue) {
                    // console.log('modelData SET', newValue);
                    if (this.exceedsMaxItems(newValue)) {
                        return;
                    }

                    // The standard Vue way to update a prop used with v-model is to emit the 'input' event.
                    this.$emit('input', newValue);
                }
            }
        },
        data() {
            return {
                checkboxValues: []
            }
        },
        methods: {
            handleChange: function (name, value) {
                // console.log('handleChange name', name);
                // console.log('handleChange value', value);
                if (this.exceedsMaxItems(value)) {
                    this.$emit('input', [...this.modelData]);
                    return;
                }

                let checkboxValues = Array.isArray(value) ? [...value] : []
                this.$emit('input', checkboxValues);
            },
            exceedsMaxItems: function (candidateValues) {
                const maxItems = parseInt(this.item.props.maxItems, 10);
                if (!maxItems || !Array.isArray(candidateValues)) {
                    return false;
                }

                return candidateValues.length > maxItems;
            },
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>

<style scoped>
 >>> .v-input__slot {
        align-items: start !important;
        /* justify-content: start !important; */
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/checkbox-list.vue